/**
 * @Author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 2020-Oct-11
 *
 **/

const registerFormValidator = {
    username: {
        required: value => !!value || 'El campo Usuario es requerido.',
            min_max: v => v.length >=4 && v.length<=15 || 'Debe ser una cadena de entre 4 y 15 caracteres.',
            valid_char: v => /^\w+$/.test(v) || 'Únicamente son válidos caracteres alfanuméricos y/o guión bajo'
    },
    email: {
        required: value => !!value || 'El campo Email es requerido.',
            valid_email: v =>  /\S+@\S+\.\S+/.test(v) || 'El email no es válido',
        emailMatch: (confirmarEmail, email) => confirmarEmail === email || 'El correo no coincide'
    },
    telefono: {
        required: value => !!value || 'El campo celular es requerido.',
        digits_10: v => v.length === 10 || 'El número de teléfono debe ser de 10 dígitos',
        telefonoMatch: (confirmarTelefono, telefono) => confirmarTelefono === telefono || 'El número no coincide',
    },
    password: {
        required: value => !!value || 'El campo contraseña es requerido.',
        min: v => (!!v && v.length >= 8) || 'Se requiere al menos 8 caracteres',
        passwordMatch: (confirmPassword, password) => confirmPassword === password || 'Las contraseñas no coinciden'
    },
    curp: {
        required: value => !!value || 'El campo CURP es requerido.',
        pattern_valid: curp =>
            !curp ||
            /^[A-Z]{1}[AEIOU]{1}[A-Z]{2}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])[HM]{1}(AS|BC|BS|CC|CL|CM|CS|CH|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)[B-DF-HJ-NP-TV-Z]{3}[0-9A-Z]{1}[0-9]{1}$/.test(curp.toUpperCase()) ||
            'Ingresa un CURP válido.',
    },
    name: {
        required: value => !!value || 'El campo Nombre es requerido.',
    },
    lastname_pat: {
        required: value => !!value || 'El campo Apellido paterno es requerido.',
    },
    rfc: {
        required: value => !!value || 'El campo RFC es requerido.',
        physic_pattern_valid: rfc => !rfc || /^([A-ZÑ\x26]{4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])([A-Z]|[0-9]){2}([A-Z]|[0-9]){1})?$/.test(rfc.toUpperCase()) || 'Ingresa un RFC válido para personas físicas.',
        moral_pattern_valid: rfc => /^([A-ZÑ\x26]{3}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])([A-Z]|[0-9]){2}([A-Z]|[0-9]){1})?$/.test(rfc.toUpperCase()) || 'Ingresa un RFC válido para personas morales.',
    },
    code: {
        required: value => !!value || 'El código es requerido.',
        length: length => value => (value && value.length === length) || `El código debe tener ${length} caracteres.`,
        numeric: value => /^\d+$/.test(value) || 'El código debe contener solo números.'
    },
    term_and_condition: {
        required: value => !!value || 'Éste campo es requerido.',
    }
}

export default registerFormValidator;